export { default } from "./patientPortalCtaBanner";
